import { Injectable } from "@angular/core";
import { Configuration } from "../configurations/shared.config";
import { HttpService } from "./http.service";

@Injectable()
export class AltairLayerService {

    constructor(private _http: HttpService) { }

    getPOI(pointlist) {
        return this._http.post(Configuration.urls.webApiEndpoint + Configuration.urls.poiGetUrl, pointlist, null, false);
    }

    getBranch(pointlist) {
        return this._http.post(Configuration.urls.webApiEndpoint + Configuration.urls.getBranchViewsUrl, pointlist, null, false);
    }

    getGeofence(pointlist) {
        return this._http.post(Configuration.urls.webApiEndpoint + Configuration.urls.GeofenceViewUrl, pointlist, null, false);
    }
}


// WEBPACK FOOTER //
// D:/TFS/Softec.FMS-Core-Live/Source/Frontend/Web/Softec.FMS.Client.WebView-ng4/app/shared/services/altairLayer.service.ts